import * as Yup from "yup";

export const createAssetSchema = Yup.object().shape({
  asset_name: Yup.string()
    .required("Please fill in the asset name")
    .trim()
    .min(3, "Asset name should have at least 3 characters"),

  asset_code: Yup.string()
    .required("Please fill in the asset code")
    .trim()
    .min(3, "Asset code should have at least 3 characters"),

    asset_image: Yup.mixed()
    .test(
      "fileType",
      "Unsupported file format (JPEG, PNG, GIF only)",
      (value) => {
        if (!value || !value.length) return true; 
        const file = value[0];
        return ["image/jpeg", "image/png", "image/gif"].includes(file.type);
      }
    )
    .test("fileSize", "File too large (max 5MB)", (value) => {
      if (!value || !value.length) return true;
      const file = value[0];
      return file.size <= 5 * 1024 * 1024; 
    }),

  // status: Yup.string().required("Please select the asset status").trim(),

  asset_category: Yup.string()
    .required("Please select the asset category")
    .trim(),

  room_id: Yup.string()
    .required("Please enter the asset location")
    .trim(),
  asset_status: Yup.string().required(),

  brand: Yup.string().trim().required("Please enter the asset brand"),
  model: Yup.string().trim().required("Please enter the asset model"),
  description: Yup.string().nullable().trim(),
  warrenty_vendor: Yup.string().nullable().trim(),
  vendor_name: Yup.string().nullable().trim(),
  po_number: Yup.string().nullable().trim(),
  invoice_number: Yup.string().nullable().trim(),

  invoice_date: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Invoice date must be a valid date"),

  purchase_date: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Purchase date must be a valid date"),

  purchase_price: Yup.number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Purchase price must be a valid number")
    .positive("Purchase price must be a positive number"),

  insurance_start_date: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Insurance start date must be a valid date"),

  insurance_end_date: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Insurance end date must be a valid date"),

  warrenty_start_date: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Warranty start date must be a valid date"),

  warrenty_end_date: Yup.date()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Warranty end date must be a valid date"),
});
